import { useEffect, useState } from "react";
import { documentRegistryFilters } from "src/api/config";
import Trash from "src/components/ui-icons/buttons/Trash";
import { useAppSelector } from "src/hooks/redux";
import { deleteItemRequest, getItemsRequest } from "src/modules/spItems/api";
import CustomRadio from "src/pages/DashboardPage/acadia/components/Tests/components/Ui/CustomRadio";
import { SelectedCurrentUser } from "src/modules/users/types";
import { selectCurrentUser } from "src/modules/users/selector";
import { UserAvatar } from "src/components/ui/avatar/Avatar";
import { FlexCol } from "src/utils/flexLayouts";
import Loading from "src/components/Loading";

export const FavoriteFiltersList = ({ setFilters, setDisplayFilters, setGetListDocuments, reRenderFilterSettings, setReRenderFilterSettings, setFiltersParams }: any) => {

  const [favoriteFilters, setFavoriteFilters] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);

  const deleteFilter = (id: number) => {
    deleteItemRequest({
      listName: documentRegistryFilters,
      ID: id
    }).then(() => {
      setReRenderFilterSettings(!reRenderFilterSettings);
    })
  };

  useEffect(() => {
    if (currentUser.email) {
      getItemsRequest({ listName: documentRegistryFilters, filters: { Creator: currentUser.email } }).then(results => {
        setFavoriteFilters([...results.items]);
        setLoading(false);
      });
    }
  }, [reRenderFilterSettings, currentUser]);

  const changeFiltersHandle = (filter: any) => {
    setFilters(filter.DocumentsFilters && JSON.parse(filter.DocumentsFilters) || {});
    setDisplayFilters(filter.DisplayFilters && JSON.parse(filter.DisplayFilters) || {});
    setFiltersParams(filter.Filters && JSON.parse(filter.Filters) || {});
    setGetListDocuments(false);
    setOpen(false);
  }

  return (
    <>
      {loading &&
        <FlexCol className="flex w-6 h-6">
          <Loading />
        </FlexCol> ||
        <>
          {favoriteFilters.length > 0 &&
            <div>
              {!open ? (
                <svg className="cursor-pointer hover:text-darkblue" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setOpen(!open)}>
                  <path
                    d="M1.62106 1.55277L1.62103 1.5528L1.62526 1.55693L9.65026 9.39443L10.0013 9.73724L10.3507 9.39276L18.3757 1.48027L18.3782 1.47777C18.5204 1.33553 18.7288 1.33553 18.8711 1.47777C19.0129 1.61959 19.0133 1.8272 18.8723 1.9694C18.8719 1.96982 18.8715 1.97025 18.8711 1.97067L10.2492 10.4426L10.2492 10.4426L10.2461 10.4457C10.1016 10.5901 10.0343 10.5992 9.99961 10.5992C9.91122 10.5992 9.83465 10.5776 9.72998 10.4979L1.12692 2.04442C0.985926 1.90221 0.986341 1.69459 1.12816 1.55277C1.2704 1.41053 1.47882 1.41053 1.62106 1.55277Z"
                    fill="currentColor"
                    strokeWidth="1.5"
                  />
                </svg>
              ) : (
                <div className="relative">
                  <svg className="cursor-pointer" width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => setOpen(!open)}>
                    <path
                      d="M10.3507 2.60724L10.0004 2.26193L9.64941 2.60641L1.62441 10.4814L1.62439 10.4814L1.62106 10.4847C1.47882 10.627 1.2704 10.627 1.12816 10.4847C0.986342 10.3429 0.985926 10.1353 1.12692 9.99309L9.75005 1.51992L9.75006 1.51994L9.75316 1.51683C9.8954 1.3746 10.1038 1.3746 10.2461 1.51683L10.246 1.51685L10.2492 1.51992L18.8711 9.99183C18.8715 9.99226 18.8719 9.99268 18.8723 9.9931C19.0133 10.1353 19.0129 10.3429 18.8711 10.4847C18.7968 10.559 18.6935 10.6008 18.6246 10.6008C18.5363 10.6008 18.4598 10.5792 18.3553 10.4997L10.3507 2.60724Z"
                      fill="#9CA3AF"
                      stroke="#012169"
                    />
                  </svg>
                  <div className="absolute top-5 right-0 z-[50] w-[600px]">
                    {favoriteFilters.map((filter: any) => (
                      <div className="flex flex-col gap-5 bg-[#ffffff] p-5 rounded-lg shadow-md mb-[10px] hover:bg-[#F3F4F6]" key={filter.ID}>
                        <div className="flex justify-between">
                          <div className="flex gap-[8px]">
                            <button onClick={() => changeFiltersHandle(filter)} className="hover:cursor-pointer">
                              <CustomRadio />
                            </button>
                            <span className="text-[#111928]">{filter.Title}</span>
                          </div>
                          <button className="hover:cursor-pointer" onClick={() => deleteFilter(filter.ID)}>
                            <Trash />
                          </button>
                        </div>
                        <ul className="flex flex-col w-full gap-2">
                          {Object.keys(JSON.parse(filter.DisplayFilters)).map((key: string) => (
                            <li className="w-full">
                              {key === 'Collection' && <><span className="text-[#637381]">Коллекция: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Department' && <><span className="text-[#637381]">Подразделения/Функция: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Sector' && <><span className="text-[#637381]">Колонна/Направление/Отдел: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Process' && <><span className="text-[#637381]">Блок колонны/Участок: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'DocType' && <><span className="text-[#637381]">Тип документа: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Lines' && <><span className="text-[#637381]">Линия розлива: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Critical' && <><span className="text-[#637381]">Критичность: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key]}</span></>}
                              {key === 'Equipments_Title' && <><span className="text-[#637381]">Название оборудования: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Equipments_Manufacturer' && <><span className="text-[#637381]">Производитель оборудования: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Equipments_Model' && <><span className="text-[#637381]">Модель оборудования: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Equipments_TypeEquipment' && <><span className="text-[#637381]">Тип оборудования: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'Equipments_SAP' && <><span className="text-[#637381]">SAP № технического места: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key].join(', ')}</span></>}
                              {key === 'ResponsibleForRevisionEmail' && <><span className="text-[#637381]">Ответственный за пересмотр: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key]}</span></>}
                              {key === 'AuthorEmail' && <><span className="text-[#637381]">Автор: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key]}</span></>}
                              {key === 'DateForRevision' && <><span className="text-[#637381]">Пересмотр документа: </span><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key]}</span></>}
                              {key === 'Title' && <><span className="text-[#111928]">{JSON.parse(filter.DisplayFilters)[key]}</span></>}
                            </li>
                          ))}
                        </ul>
                        <div className="flex gap-[8px]">
                          <span className="text-[#637381]">Создатель: </span>
                          <span className="rounded p-1 flex flex-row items-center">
                            <UserAvatar
                              avatar={currentUser.avatar}
                              shortName={currentUser.shortName}
                              displayName={currentUser.displayName}
                              email={filter.Creator}
                            />
                            <span className="text-[#111928]">{currentUser.displayName}</span>
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          }
        </>
      }
    </>
  );
};
